module.exports = __webpack_public_path__ + "static/media/banner_l_01.b42f17cb.jpg";